module.exports = __webpack_public_path__ + "static/calendar-3c8ff8cfd0725c627c62f8b0b24ae020.png";